/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function WorkerQueueStatusFromJSON(json) {
    return WorkerQueueStatusFromJSONTyped(json, false);
}
export function WorkerQueueStatusFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        activeCount: json['activeCount'],
        queuedCount: json['queuedCount'],
    };
}
export function WorkerQueueStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        activeCount: value.activeCount,
        queuedCount: value.queuedCount,
    };
}
